import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Target, CalendarDays, Mail, ArrowRight, Users, BarChart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CorporatePartnershipsPage = ({ session, profile }: { session: any; profile: any }) => {
  const navigate = useNavigate();

  const actionCards = [
    {
      title: 'RFQ Requests',
      description: 'Manage and respond to corporate partnership inquiries',
      icon: <Users className="h-8 w-8" />,
      color: 'bg-indigo-500',
      path: '/dashboard/corporate-events/rfqs'
    },

    {
      title: 'Booked Events',
      description: 'Manage your confirmed corporate partnership events',
      icon: <CalendarDays className="h-8 w-8" />,
      color: 'bg-green-500',
      path: '/dashboard/events'
    },

  ];

  React.useEffect(() => {
    navigate('/dashboard/events');
  }, [navigate]);
  return null;
};

export default CorporatePartnershipsPage;
